
class crop_portrait_ratio1x1_class {
   static readonly cropName = 'portrait_ratio1x1'; 
   static readonly w320h320= {height:320,width:320};
   static readonly w540h540= {height:540,width:540};
   static readonly w890h890= {height:890,width:890};
   static readonly w1140h1140= {height:1140,width:1140};
   static readonly w1750h1750= {height:1750,width:1750};

   private constructor() {}
}

class crop_portrait_ratio3x4_class {
   static readonly cropName = 'portrait_ratio3x4'; 
   static readonly w324h432= {height:432,width:324};
   static readonly w414h552= {height:552,width:414};
   static readonly w544h725= {height:725,width:544};
   static readonly w780h1040= {height:1040,width:780};
   static readonly w1024h1365= {height:1365,width:1024};

   private constructor() {}
}

class crop_landscape_ratio7x2_class {
   static readonly cropName = 'landscape_ratio7x2'; 
   static readonly w585h329= {height:329,width:585};
   static readonly w1024h293= {height:293,width:1024};
   static readonly w1440h411= {height:411,width:1440};
   static readonly w1750h500= {height:500,width:1750};
   static readonly w2051h586= {height:586,width:2051};

   private constructor() {}
}

class crop_landscape_ratio4x3_class {
   static readonly cropName = 'landscape_ratio4x3'; 
   static readonly w320h240= {height:240,width:320};
   static readonly w375h281= {height:281,width:375};
   static readonly w414h310= {height:310,width:414};
   static readonly w500h375= {height:375,width:500};
   static readonly w768h576= {height:576,width:768};
   static readonly w1000h750= {height:750,width:1000};
   static readonly w1200h900= {height:900,width:1200};

   private constructor() {}
}

class crop_landscape_ratio20x7_class {
   static readonly cropName = 'landscape_ratio20x7'; 
   static readonly w890h312= {height:312,width:890};
   static readonly w1241h434= {height:434,width:1241};
   static readonly w1440h504= {height:504,width:1440};
   static readonly w2080h728= {height:728,width:2080};
   static readonly w2780h973= {height:973,width:2780};

   private constructor() {}
}

class crop_landscape_ratio16x9_class {
   static readonly cropName = 'landscape_ratio16x9'; 
   static readonly w320h180= {height:180,width:320};
   static readonly w585h329= {height:329,width:585};
   static readonly w960h540= {height:540,width:960};
   static readonly w1272h716= {height:716,width:1272};
   static readonly w1440h810= {height:810,width:1440};
   static readonly w1920h1080= {height:1080,width:1920};

   private constructor() {}
}


export class Crops {
   static readonly portrait_ratio1x1 = crop_portrait_ratio1x1_class;
   static readonly portrait_ratio3x4 = crop_portrait_ratio3x4_class;
   static readonly landscape_ratio7x2 = crop_landscape_ratio7x2_class;
   static readonly landscape_ratio4x3 = crop_landscape_ratio4x3_class;
   static readonly landscape_ratio20x7 = crop_landscape_ratio20x7_class;
   static readonly landscape_ratio16x9 = crop_landscape_ratio16x9_class;
   private constructor() {}
}
